let bundleVariantData = [];
let currentStep = 0;

// ============================================================
// HELPER UTILITIES
// ============================================================

function qs(selector, context) {
  return (context || document).querySelector(selector);
}
function qsa(selector, context) {
  return Array.from((context || document).querySelectorAll(selector));
}
function on(eventType, selector, handler, context) {
  (context || document).addEventListener(eventType, function (e) {
    var target = e.target.closest(selector);
    if (target) handler.call(target, e);
  });
}
function show(el) { if (el) el.style.display = ''; }
function hide(el) { if (el) el.style.display = 'none'; }
function showFlex(el) { if (el) el.style.display = 'flex'; }
function toggle(el, condition) {
  if (el) el.style.display = condition ? '' : 'none';
}
function hasClass(el, cls) { return el && el.classList.contains(cls); }
function addClass(el, cls) { if (el) el.classList.add(cls); }
function removeClass(el, cls) { if (el) el.classList.remove(cls); }
function toggleClass(el, cls, force) {
  if (el) el.classList.toggle(cls, force);
}
function css(el, styles) {
  if (!el) return;
  Object.assign(el.style, styles);
}
function val(el, v) {
  if (v === undefined) return el ? el.value : '';
  if (el) el.value = v;
}
function attr(el, name, v) {
  if (!el) return '';
  if (v === undefined) return el.getAttribute(name) || '';
  el.setAttribute(name, v);
}
function prop(el, name, v) {
  if (!el) return;
  el[name] = v;
}
function text(el, t) { if (el) el.textContent = t; }
function html(el, h) { if (el) el.innerHTML = h; }
function data(el, key, v) {
  if (!el) return undefined;
  if (v === undefined) return el._customData ? el._customData[key] : undefined;
  el._customData = el._customData || {};
  el._customData[key] = v;
}
function slideToggle(el, duration) {
  duration = duration || 300;
  if (!el) return;
  if (el.style.display === 'none' || el.style.display === '') {
    el.style.display = 'block';
    el.style.maxHeight = '0';
    el.style.overflow = 'hidden';
    el.style.transition = 'max-height ' + duration + 'ms ease';
    requestAnimationFrame(function () {
      el.style.maxHeight = el.scrollHeight + 'px';
    });
    setTimeout(function () {
      el.style.maxHeight = '';
      el.style.overflow = '';
    }, duration);
  } else {
    el.style.overflow = 'hidden';
    el.style.maxHeight = el.scrollHeight + 'px';
    el.style.transition = 'max-height ' + duration + 'ms ease';
    requestAnimationFrame(function () {
      el.style.maxHeight = '0';
    });
    setTimeout(function () {
      el.style.display = 'none';
      el.style.maxHeight = '';
      el.style.overflow = '';
    }, duration);
  }
}
function slideUp(el, duration) {
  duration = duration || 300;
  if (!el) return;
  el.style.overflow = 'hidden';
  el.style.maxHeight = el.scrollHeight + 'px';
  el.style.transition = 'max-height ' + duration + 'ms ease';
  requestAnimationFrame(function () {
    el.style.maxHeight = '0';
  });
  setTimeout(function () {
    el.style.display = 'none';
    el.style.maxHeight = '';
    el.style.overflow = '';
  }, duration);
}
function closest(el, selector) {
  return el ? el.closest(selector) : null;
}
function findIn(el, selector) {
  return el ? Array.from(el.querySelectorAll(selector)) : [];
}
function findOne(el, selector) {
  return el ? el.querySelector(selector) : null;
}
function outerHeight(el) {
  if (!el) return 0;
  var style = window.getComputedStyle(el);
  return el.offsetHeight + parseInt(style.marginTop) + parseInt(style.marginBottom);
}
function ajax(options) {
  var xhr = new XMLHttpRequest();
  xhr.open(options.type || 'GET', options.url);
  if (options.contentType) xhr.setRequestHeader('Content-Type', options.contentType);
  xhr.onload = function () {
    if (xhr.status >= 200 && xhr.status < 300) {
      try { options.success && options.success(JSON.parse(xhr.responseText)); }
      catch (e) { options.success && options.success(xhr.responseText); }
    } else {
      options.error && options.error(xhr, xhr.statusText);
    }
  };
  xhr.onerror = function () { options.error && options.error(xhr, 'error'); };
  xhr.send(options.data || null);
}

// ============================================================
// DOCUMENT READY
// ============================================================

document.addEventListener('DOMContentLoaded', function () {

  // ---- MAIN MULTI-STEP LOGIC ----
  var $tabItems = qsa('.step-title');
  var $blockItems = qsa('.block-item');
  var $progressPercent = qs('#progressPercent');
  var totalSteps = $tabItems.length;

  function updateUI() {
    console.log('currentStep', currentStep, bundleVariantData.length);

    var section = qs('.multi-step-bundle-builder-section');
    var errorMsg = section ? findOne(section, '.cart-footer .error-msg') : null;

    if (currentStep >= 3 && bundleVariantData.length === 0) {
      if (errorMsg) show(errorMsg);
      return false;
    } else {
      if (errorMsg) hide(errorMsg);
    }

    if (bundleVariantData.length > 0) {
      var stickyCart = section ? findOne(section, '.sticky-cart-container') : null;
      if (stickyCart) toggle(stickyCart, currentStep !== 3);
    }

    $tabItems.forEach(function (el, i) {
      removeClass(el, 'active');
      removeClass(el, 'current-active');
      if (i < currentStep) addClass(el, 'active');
      if (i === currentStep) { addClass(el, 'current-active'); addClass(el, 'active'); }
    });

    $blockItems.forEach(function (el, i) {
      toggleClass(el, 'active', i === currentStep);
    });

    if ($progressPercent) {
      $progressPercent.style.width = Math.round(((currentStep + 1) / totalSteps) * 100) + '%';
    }

    var backBtn = qs('#backBtn');
    var nextBtn = qs('#nextBtn');
    if (backBtn) prop(backBtn, 'disabled', currentStep === 0);
    if (nextBtn) prop(nextBtn, 'disabled', currentStep === totalSteps - 1);

    sameBoxCard();
    if (currentStep === 3) reserveTimer();
    else if (currentStep === 2) accessoriesBoxCard();
  }

  on('click', '#nextBtn', function () {
    var section = qs('.multi-step-bundle-builder-section');
    if (currentStep < totalSteps - 1) {
      currentStep++;
      updateUI();
    } else {
      var errorMsg = section ? findOne(section, '.cart-footer .error-msg') : null;
      if (errorMsg) show(errorMsg);
    }
  });

  on('click', '#backBtn', function () {
    if (currentStep > 0) { currentStep--; updateUI(); }
  });

  on('click', '.step-title', function () {
    var allTabs = qsa('.step-title');
    currentStep = allTabs.indexOf(this);
    if (bundleVariantData.length === 0) return false;
    updateUI();
  });

  updateUI();
  sameBoxCard();
  setColorName();

  // ---- FAQ ACCORDION ----
  on('click', '.bundle-faq--wrapper .faq-accordion .faq-header', function () {
    var accordion = closest(this, '.faq-accordion');
    toggleClass(accordion, 'active');
    slideToggle(findOne(accordion, '.faq-body'));
    toggleClass(this, 'open');

    var siblings = qsa('.bundle-faq--wrapper .faq-accordion').filter(function (el) {
      return el !== accordion;
    });
    siblings.forEach(function (sib) {
      removeClass(sib, 'active');
      slideUp(findOne(sib, '.faq-body'));
      var header = findOne(sib, '.faq-header');
      if (header) removeClass(header, 'open');
    });
  });
});

// ============================================================
// RESET TABS AND PROGRESS
// ============================================================

function resetTabsAndProgress() {
  var $tabItems = qsa('.multi-step-bundle-builder-section .step-title');
  var $blockItems = qsa('.multi-step-bundle-builder-section .block-item');
  var $progressPercent = qs('#progressPercent');
  var totalSteps = $tabItems.length;

  currentStep = 0;

  $tabItems.forEach(function (el, i) {
    removeClass(el, 'active');
    removeClass(el, 'current-active');
    if (i === 0) { addClass(el, 'current-active'); addClass(el, 'active'); }
  });

  $blockItems.forEach(function (el, i) {
    toggleClass(el, 'active', i === 0);
  });

  if ($progressPercent) {
    $progressPercent.style.width = Math.round((1 / totalSteps) * 100) + '%';
  }

  var backBtn = qs('#backBtn');
  var nextBtn = qs('#nextBtn');
  if (backBtn) prop(backBtn, 'disabled', true);
  if (nextBtn) prop(nextBtn, 'disabled', false);

  var stickyCart = qs('.multi-step-bundle-builder-section .sticky-cart-container');
  if (stickyCart) hide(stickyCart);

  sameBoxCard();
}

// ============================================================
// sliderRefresh — Slick REMOVED, kept as no-op for safety
// ============================================================

function sliderRefresh() {
  // Slick slider has been removed.
  // If you add a new slider library, initialize/refresh it here.
}

// ============================================================
// STICKY CART TOGGLE
// ============================================================

on('click', '.sticky-cart-container .cart-pack-list', function () {
  var cartContainer = qs('#cartContainer');
  if (cartContainer) cartContainer.classList.toggle('collapsed');
});

// ============================================================
// COLOR SWATCH CLICK
// ============================================================

on('click', '.grid-product__colors .color-swatch--with-image', function () {
  var siblings = findIn(this.parentElement, '.color-swatch--with-image');
  siblings.forEach(function (s) { removeClass(s, 'active'); });
  addClass(this, 'active');

  var getColor = attr(this, 'data-value');
  var parentDiv = this.parentElement.parentElement;
  var selectedColorEl = findOne(parentDiv, '.selected-color');
  if (selectedColorEl) text(selectedColorEl, getColor);

  var productInfo = closest(this, '.product-info');
  var selectedVariantId = getVariantId(productInfo);
  var quantitySelector = findOne(productInfo, '.quantity-selector');
  var addButton = findOne(productInfo, '.product-btn');

  var variantData = false;
  if (selectedVariantId) {
    variantData = bundleVariantData.find(function (item) {
      return item.variant_id == selectedVariantId;
    });
  }

  var totalqnt = getTotalVariantQuantity(selectedVariantId);
  var qVal = findOne(quantitySelector, '.quantity-value');
  if (qVal) {
    if (variantData) {
      show(quantitySelector);
      if (addButton) hide(addButton);
      val(qVal, totalqnt);
      attr(qVal, 'data-variant-id', selectedVariantId);
    } else {
      hide(quantitySelector);
      if (addButton) show(addButton);
      var min = parseInt(attr(qVal, 'min')) || 1;
      val(qVal, min);
      attr(qVal, 'data-variant-id', selectedVariantId);
    }
  }
});

// ============================================================
// ADD TO BUNDLE BUTTON CLICK
// ============================================================

on('click', '.multi-step-bundle-builder-section .product-btn', function () {
  var quantitySelector = findOne(this.closest('.product-info').parentElement, '.quantity-selector') ||
    findOne(closest(this, '.product-info'), '.quantity-selector');

  // Try: sibling search
  var parent = this.parentElement;
  var qSel = findOne(parent, '.quantity-selector') || findOne(parent.parentElement, '.quantity-selector');
  if (qSel) css(qSel, { display: 'flex' });
  hide(this);

  var obj = closest(this, '.product-info');
  var handleVariant = selectVariantGet(obj);
  console.log('handleVariant', handleVariant);
  if (handleVariant !== undefined && handleVariant !== '') {
    bundlePackHtml();
  }
});

// ============================================================
// OPTION CHANGE VARIANT
// ============================================================

on('change', '.multi-step-bundle-builder-section .product-variant-select.dynamic-option', function () {
  var productInfo = closest(this, '.product-info');
  var selectedVariantId = getVariantId(productInfo);

  var quantitySelector = findOne(productInfo, '.quantity-selector');
  var addButton = findOne(productInfo, '.product-btn');

  var variantData = false;
  if (selectedVariantId) {
    variantData = bundleVariantData.find(function (item) {
      return item.variant_id == selectedVariantId;
    });
  }

  var totalqnt = getTotalVariantQuantity(selectedVariantId);
  var qVal = quantitySelector ? findOne(quantitySelector, '.quantity-value') : null;

  if (variantData) {
    if (quantitySelector) show(quantitySelector);
    if (addButton) hide(addButton);
    if (qVal) val(qVal, totalqnt);
  } else {
    if (quantitySelector) hide(quantitySelector);
    if (addButton) show(addButton);
    if (qVal) {
      var min = parseInt(attr(qVal, 'min')) || 1;
      val(qVal, min);
    }
  }
});

// ============================================================
// ACCESSORIES BOX CARD
// ============================================================

function accessoriesBoxCard() {
  var section = qs('.multi-step-bundle-builder-section');
  if (!section) return;
  var accessories = findOne(section, '.add-accessories');
  if (!accessories) return;

  var heights = [];
  findIn(accessories, '.product-variant-select-wrapper').forEach(function (el) {
    heights.push(el.offsetHeight);
  });

  var maxValue = Math.max.apply(Math, heights);
  console.log('maxValue', maxValue);

  findIn(accessories, '.product-variant-select-wrapper').forEach(function (el) {
    el.style.height = maxValue + 'px';
  });
}

// ============================================================
// GET TOTAL VARIANT QUANTITY
// ============================================================

function getTotalVariantQuantity(variantId) {
  if (!variantId || !bundleVariantData || !Array.isArray(bundleVariantData)) return 0;
  var total = 0;
  bundleVariantData.forEach(function (item) {
    if (item.variant_id == variantId) total += parseInt(item.variant_quantity) || 0;
  });
  return total;
}

// ============================================================
// QUANTITY PICKER — PLUS
// ============================================================

on('click', '.multi-step-bundle-builder-section .quantity-btn.plus', function () {
  var btn = this;
  var selector = btn.parentElement;
  var input = findOne(selector, '.quantity-value');
  var current = parseInt(val(input)) || 0;
  var variantId = parseInt(attr(input, 'data-variant-id'));

  if (!variantId) return;

  var newVal = current + 1;

  if (hasClass(btn, 'bundle-picker')) {
    var section = qs('.multi-step-bundle-builder-section');
    findIn(section, '.quantity-selector .quantity-value[data-variant-id="' + variantId + '"]').forEach(function (inp) {
      val(inp, newVal);
      inp.dispatchEvent(new Event('change'));
      if (inp.parentElement) show(inp.parentElement);
      var productBtn = findOne(inp.parentElement.parentElement, '.product-btn');
      if (productBtn) hide(productBtn);
    });

    bundleVariantData.push({
      variant_price: attr(input, 'data-vprice'),
      variant_c_price: attr(input, 'data-compare-vprice'),
      variant_original_price: attr(input, 'data-original-vprice'),
      variant_original_cprice: attr(input, 'data-original-compare-vprice'),
      variant_image: attr(input, 'data-vimage'),
      variant_id: variantId,
      product_title: attr(input, 'data-ptitle'),
      variant_handle: attr(input, 'data-vhandle'),
      variant_quantity: 1
    });
  } else {
    val(input, newVal);
    input.dispatchEvent(new Event('change'));
  }

  var obj = closest(btn, '.product-info');
  if (obj) {
    selectVariantGet(obj);
    setTimeout(bundlePackHtml, 100);
  }
});

// ============================================================
// QUANTITY PICKER — MINUS
// ============================================================

on('click', '.multi-step-bundle-builder-section .quantity-btn.minus', function () {
  var selector = this.parentElement;
  var input = findOne(selector, '.quantity-value');
  var current = parseInt(val(input)) || 1;
  var variantId = parseInt(attr(input, 'data-variant-id'));

  if (!variantId) return;
  console.log('variantId', variantId);

  var section = qs('.multi-step-bundle-builder-section');

  if (current === 1) {
    hide(selector);
    var productBtn = findOne(selector.parentElement, '.product-btn');
    if (productBtn) show(productBtn);

    var removeIndex = bundleVariantData.findIndex(function (item) {
      return item.variant_id == variantId;
    });
    if (removeIndex > -1) bundleVariantData.splice(removeIndex, 1);

    // Remove cart item card
    var itemCards = findIn(section, '.sticky-cart-container .item-card');
    itemCards.filter(function (el) {
      return el.dataset.variantId == variantId;
    }).slice(0, 1).forEach(function (el) { el.remove(); });

    // Remove review product card
    var productCards = findIn(section, '.product-card-wrapper .product-card');
    productCards.filter(function (el) {
      return el.dataset.variantId == variantId;
    }).slice(0, 1).forEach(function (el) { el.remove(); });

    if (hasClass(this, 'bundle-picker')) {
      var qInputs = findIn(section, '.collection-item .quantity-selector .quantity-value[data-variant-id="' + variantId + '"]');
      qInputs.forEach(function (inp) {
        if (inp.parentElement) hide(inp.parentElement);
        var pb = findOne(inp.parentElement.parentElement, '.product-btn');
        if (pb) show(pb);
      });
    }

    console.log('bundleVariantData length', bundleVariantData.length);

    if (bundleVariantData.length === 0) {
      var comparePrice = Shopify.formatMoney(0);
      var tprice = Shopify.formatMoney(0);
      findIn(section, '.price-section .original-price.compare-price').forEach(function (el) { hide(el); });
      findIn(section, '.price-section .discounted-price.main-price').forEach(function (el) { text(el, tprice); });
    }
  } else {
    var newVal = current - 1;
    if (newVal < 1) newVal = 1;
    val(input, newVal);
    input.dispatchEvent(new Event('change'));

    var removeIndex2 = bundleVariantData.findIndex(function (item) {
      return item.variant_id == variantId;
    });
    if (removeIndex2 > -1) bundleVariantData.splice(removeIndex2, 1);

    var totalqnt = getTotalVariantQuantity(variantId);

    if (hasClass(this, 'bundle-picker')) {
      findIn(section, '.collection-item .quantity-selector .quantity-value[data-variant-id="' + variantId + '"]').forEach(function (inp) {
        val(inp, totalqnt);
      });

      if (newVal === 1) {
        findIn(section, '.product-card-wrapper .product-card[data-variant-id="' + variantId + '"] .minus-icon').forEach(function (el) { hide(el); });
        findIn(section, '.product-card-wrapper .product-card[data-variant-id="' + variantId + '"] .remove-icon').forEach(function (el) { show(el); });
      }
    }
  }

  setTimeout(bundlePackHtml, 100);
});

// ============================================================
// SET COLOR NAME
// ============================================================

function setColorName() {
  var section = qs('.multi-step-bundle-builder-section');
  if (!section) return;
  findIn(section, '.grid-product__colors .color-swatch--with-image.active').forEach(function (el) {
    var getColor = attr(el, 'data-value');
    var parentDiv = el.parentElement.parentElement;
    var selectedColorEl = findOne(parentDiv, '.selected-color');
    if (selectedColorEl) text(selectedColorEl, getColor);
  });
}

// ============================================================
// GET VARIANT ID
// ============================================================

function getVariantId(buttonObj) {
  if (!buttonObj) return;
  var variantArray = [];

  findIn(buttonObj, '.product-variant-select.dynamic-option').forEach(function (el) {
    if (hasClass(el, 'version-variant')) {
      var selected = el.options[el.selectedIndex];
      variantArray.push({
        key: attr(el, 'data-option-name'),
        value: attr(selected, 'data-option'),
        main_value: attr(selected, 'data-value')
      });
    }
  });

  var colorSwatch = findOne(buttonObj, '.grid-product__colors .color-swatch-ci.active');
  if (colorSwatch) {
    variantArray.push({
      key: 'Color',
      value: attr(colorSwatch, 'data-option'),
      main_value: attr(colorSwatch, 'data-value'),
      color_image: attr(colorSwatch, 'data-color-img')
    });
  }

  findIn(buttonObj, '.product-variant-select.dynamic-option').forEach(function (el) {
    if (!hasClass(el, 'version-variant')) {
      var selected = el.options[el.selectedIndex];
      variantArray.push({
        key: attr(el, 'data-option-name'),
        value: attr(selected, 'data-option'),
        main_value: attr(selected, 'data-value')
      });
    }
  });

  var variant_handle = variantArray.map(function (opt) { return opt.value; }).join('-');
  var variantId = '';
  if (variant_handle) {
    var opt = findOne(buttonObj, '.hidden-variant-select option[data-vhandle="' + variant_handle + '"]');
    if (opt) variantId = opt.value;
  }
  return variantId;
}

// ============================================================
// CALCULATE STRAP TOTALS
// ============================================================

function calculateStrapTotals(bundleData) {
  var strapCount = 0, totalPrice = 0, totalComparePrice = 0, strapCheck = 0;

  for (var i = 0; i < bundleData.length; i++) {
    var item = bundleData[i];
    if (item) {
      var pt = (item.product_title || '').toLowerCase();
      if (pt.includes('strap') && !pt.includes('strap bag')) {
        strapCheck = 1;
        strapCount += parseInt(item.variant_quantity) || 0;
      }
    }
  }

  var paidStraps = 0, freeStraps = 0, strapBoxFree = 0;

  if (strapCount <= 1)        { paidStraps = strapCount; freeStraps = 0; strapBoxFree = 1; }
  else if (strapCount === 2)  { paidStraps = 1; freeStraps = 1; }
  else if (strapCount === 3)  { paidStraps = 2; freeStraps = 1; strapBoxFree = 3; }
  else if (strapCount === 4)  { paidStraps = 2; freeStraps = 2; }
  else if (strapCount === 5)  { paidStraps = 2; freeStraps = 3; }
  else if (strapCount === 6)  { paidStraps = 3; freeStraps = 3; strapBoxFree = 6; }
  else if (strapCount === 7)  { paidStraps = 3; freeStraps = 4; }
  else if (strapCount >= 8)   { paidStraps = strapCount - 4; freeStraps = 4; }

  var section = qs('.multi-step-bundle-builder-section');
  var boxes = section ? findIn(section, '.sticky-cart-container .item-card.blank-card') : [];
  boxes.forEach(function (box) {
    toggle(box, (strapBoxFree === 1 || strapBoxFree === 3 || strapBoxFree === 6) && strapCount > 0);
  });

  var processedCount = 0;
  for (var j = 0; j < bundleData.length; j++) {
    var item2 = bundleData[j];
    if (item2) {
      var pt2 = (item2.product_title || '').toLowerCase();
      if (pt2.includes('strap') && !pt2.includes('strap bag')) {
        var quantity = parseInt(item2.variant_quantity) || 0;
        var price = parseFloat(item2.variant_original_price || 0);
        var comparePrice = parseFloat(item2.variant_original_cprice || 0);
        for (var q = 0; q < quantity; q++) {
          processedCount++;
          if (processedCount <= paidStraps) {
            totalPrice += price;
            totalComparePrice += comparePrice;
          }
        }
      }
    }
  }

  return { strapCount: strapCount, paidStraps: paidStraps, freeStraps: freeStraps, totalPrice: totalPrice, totalComparePrice: totalComparePrice, strapCheck: strapCheck };
}

// ============================================================
// SELECT VARIANT GET
// ============================================================

function selectVariantGet(buttonObj) {
  if (!buttonObj) return;
  var variantArray = [];
  var colorSwatch = findOne(buttonObj, '.grid-product__colors .color-swatch-ci.active');

  findIn(buttonObj, '.product-variant-select.dynamic-option').forEach(function (el) {
    if (hasClass(el, 'version-variant')) {
      var selected = el.options[el.selectedIndex];
      variantArray.push({
        key: attr(el, 'data-option-name'),
        value: attr(selected, 'data-option'),
        main_value: attr(selected, 'data-value')
      });
    }
  });

  if (colorSwatch) {
    variantArray.push({
      key: 'Color',
      value: attr(colorSwatch, 'data-option'),
      main_value: attr(colorSwatch, 'data-value'),
      color_image: attr(colorSwatch, 'data-color-img')
    });
  }

  findIn(buttonObj, '.product-variant-select.dynamic-option').forEach(function (el) {
    if (!hasClass(el, 'version-variant')) {
      var selected = el.options[el.selectedIndex];
      variantArray.push({
        key: attr(el, 'data-option-name'),
        value: attr(selected, 'data-option'),
        main_value: attr(selected, 'data-value')
      });
    }
  });

  var variant_handle = variantArray.map(function (opt) {
    if (opt.value !== '' && opt.value !== undefined) return opt.value;
  }).join('-');

  var selectedVariant;
  if (variant_handle) {
    selectedVariant = findOne(buttonObj.parentElement, '.hidden-variant-select option[data-vhandle="' + variant_handle + '"]');
  } else {
    var hvs = findOne(buttonObj.parentElement, '.hidden-variant-select');
    selectedVariant = hvs ? hvs.options[0] : null;
  }

  if (selectedVariant) {
    bundleVariantData.push({
      variant_price: attr(selectedVariant, 'data-vprice'),
      variant_c_price: attr(selectedVariant, 'data-compare-vprice'),
      variant_original_price: attr(selectedVariant, 'data-original-vprice'),
      variant_original_cprice: attr(selectedVariant, 'data-original-compare-vprice'),
      variant_image: attr(selectedVariant, 'data-vimage'),
      variant_id: selectedVariant.value,
      product_title: attr(selectedVariant, 'data-ptitle'),
      variant_handle: attr(selectedVariant, 'data-vhandle'),
      variant_option: variantArray,
      variant_quantity: 1
    });
    variant_handle = attr(selectedVariant, 'data-vhandle');
  }

  console.log('bundleData', bundleVariantData);
  return variant_handle;
}

// ============================================================
// FIND VARIANT INDEX
// ============================================================

function findVariantIndex(array, variantId) {
  for (var i = 0; i < array.length; i++) {
    if (array[i].variant_id === variantId) return i;
  }
  return -1;
}

// ============================================================
// REMOVE ICON CLICK (REVIEW ORDER)
// ============================================================

on('click', '.multi-step-bundle-builder-section .quantity-control .remove-icon', function () {
  var getVId = attr(this.parentElement, 'data-variant-id');
  console.log('getVariantId', getVId);
  if (!getVId) return;

  var section = qs('.multi-step-bundle-builder-section');
  findIn(section, '.product-card-wrapper .product-card[data-variant-id="' + getVId + '"]').forEach(function (el) { el.remove(); });

  var variantIndex = bundleVariantData.findIndex(function (item) { return item.variant_id == getVId; });
  if (variantIndex !== -1) bundleVariantData.splice(variantIndex, 1);

  bundlePackHtml();
});

// ============================================================
// BUNDLE PACK HTML
// ============================================================

function bundlePackHtml() {
  var totalQuantity = 0;
  var totalComparePrice = 0;
  var totalPrice = 0;
  var variantHtmlBundle = '';

  var section = qs('.multi-step-bundle-builder-section');
  if (!section) return;

  if (bundleVariantData.length > 0) {
    var stickyCart = findOne(section, '.sticky-cart-container');
    var reviewWrapper = findOne(section, '.product-card-wrapper');

    if (stickyCart) {
      var reviewBlockActive = findOne(section, '.block-item.review-block.active');
      toggle(stickyCart, !reviewBlockActive);
    }

    for (var j = 0; j < bundleVariantData.length; j++) {
      var variantId = bundleVariantData[j].variant_id;
      var variantQuantity = bundleVariantData[j].variant_quantity;
      var variantOriginlPrice = bundleVariantData[j].variant_original_price;
      var variantOriginlCPrice = bundleVariantData[j].variant_original_cprice;
      var variantImage = bundleVariantData[j].variant_image;
      var productTitle = bundleVariantData[j].product_title;
      var optionVariant = bundleVariantData[j].variant_option;
      var varaintPrice = bundleVariantData[j].variant_price;
      var varaintCPrice = bundleVariantData[j].variant_c_price;

      // REVIEW ORDER HTML
      if (reviewWrapper) {
        var existingProductCard = reviewWrapper.querySelector('.product-card[data-variant-id="' + variantId + '"]');

        var minusIcons = findIn(section, '.product-card[data-variant-id="' + variantId + '"] .quantity-btn .minus-icon');
        var removeIcons = findIn(section, '.product-card[data-variant-id="' + variantId + '"] .quantity-btn .remove-icon');

        if (variantQuantity > 1) {
          minusIcons.forEach(function (el) { show(el); });
          removeIcons.forEach(function (el) { hide(el); });
        } else {
          minusIcons.forEach(function (el) { hide(el); });
          removeIcons.forEach(function (el) { show(el); });
        }

        var getQuantity = getTotalVariantQuantity(variantId);

        if (existingProductCard) {
          var qInput = findOne(existingProductCard, '.quantity-input');
          if (qInput) val(qInput, getQuantity);
          if (getQuantity > 1) {
            findIn(existingProductCard, '.minus-icon').forEach(function (el) { show(el); });
            findIn(existingProductCard, '.remove-icon').forEach(function (el) { hide(el); });
          }
        } else {
          var previewOrderHtml = '';
          previewOrderHtml += '<div class="product-card" data-variant-id="' + variantId + '"><div class="product-image">';
          previewOrderHtml += '<img src="' + variantImage + '"></div>';
          previewOrderHtml += '<div class="product-info"><h3 class="product-title">' + productTitle + '</h3>';
          previewOrderHtml += '<div class="product-options">';

          for (var g = 0; g < optionVariant.length; g++) {
            if (optionVariant[g].key !== undefined) {
              var keyval = optionVariant[g].key.toLowerCase();
              if (keyval !== 'version') {
                var value_option = optionVariant[g].main_value;
                if (keyval === 'color') {
                  var colorImg = optionVariant[g].color_image;
                  previewOrderHtml += '<div class="option-row"><span class="option-label ' + keyval + '">' + optionVariant[g].key + ':</span>';
                  previewOrderHtml += '<span class="color--swatch"><img src="' + colorImg + '"></span>';
                  previewOrderHtml += '<span class="option-value">' + value_option + '</span></div>';
                } else {
                  previewOrderHtml += '<div class="option-row"><span class="option-label ' + keyval + '">' + optionVariant[g].key + ':</span>';
                  previewOrderHtml += '<span class="option-value">' + value_option + '</span></div>';
                }
              }
            }
          }

          previewOrderHtml += '</div>';
          previewOrderHtml += '<div class="product-pricing-quantity-wrapper"><div class="product-pricing">';
          if (varaintCPrice !== '' && varaintCPrice !== undefined) {
            previewOrderHtml += '<span class="price-original">' + varaintCPrice + '</span>';
          }
          previewOrderHtml += '<span class="price-sale">' + varaintPrice + '</span></div>';
          previewOrderHtml += '<div class="quantity-control" data-variant-id="' + variantId + '"><button class="quantity-btn minus bundle-picker" data-variant-id="' + variantId + '">';
          previewOrderHtml += '<svg class="minus-icon" style="display:none;" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M0.555542 4.5H9.44421V5.5H0.555542V4.5Z" fill="black"/></svg>';
          previewOrderHtml += '<svg class="remove-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">';
          previewOrderHtml += '<path d="M1.75 3.50002H12.25M11.0833 3.50002V11.6667C11.0833 11.9761 10.9604 12.2729 10.7416 12.4916C10.5228 12.7104 10.2261 12.8334 9.91667 12.8334H4.08333C3.77391 12.8334 3.47717 12.7104 3.25838 12.4916C3.03958 12.2729 2.91667 11.9761 2.91667 11.6667V3.50002M4.08333 3.50002L5.25 1.16669H8.75L9.91667 3.50002" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>';
          previewOrderHtml += '</svg></button>';
          previewOrderHtml += '<input type="number" class="quantity-input quantity-value" data-variant-id="' + variantId + '" value="' + getQuantity + '" data-ptitle="' + productTitle + '" data-vimage="' + variantImage + '" data-original-compare-vprice="' + variantOriginlCPrice + '" data-original-vprice="' + variantOriginlPrice + '" data-vprice="' + varaintPrice + '" data-compare-vprice="' + varaintCPrice + '" min="1" pattern="[0-9]*">';
          previewOrderHtml += '<button class="quantity-btn plus bundle-picker"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">';
          previewOrderHtml += '<path d="M5.49988 4.49988H9.44421V5.49988H5.49988V9.44421H4.49988V5.49988H0.555542V4.49988H4.49988V0.555542H5.49988V4.49988Z" fill="black"/>';
          previewOrderHtml += '</svg></button></div></div></div></div>';

          var reviewBlock = findOne(section, '.block-item.review-block');
          if (reviewBlock && previewOrderHtml !== '') {
            reviewWrapper.insertAdjacentHTML('beforeend', previewOrderHtml);
          }
        }
      }

      // STICKY BAR CART HTML
      variantHtmlBundle += '<div class="item-card image-added" data-variant-id="' + variantId + '"><button class="remove-btn">';
      variantHtmlBundle += '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">';
      variantHtmlBundle += '<rect x="1" y="1" width="20" height="20" rx="10" fill="#0F0F0F"/><rect x="1" y="1" width="20" height="20" rx="10" stroke="white" stroke-width="2"/>';
      variantHtmlBundle += '<path d="M13.9998 7.99976L7.99976 13.9998M7.99976 7.99976L13.9998 13.9998" stroke="white" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
      variantHtmlBundle += '<div class="item-image"><img src="' + variantImage + '" alt="' + productTitle + '"></div>';
      variantHtmlBundle += '<div class="item-name">' + productTitle + '</div>';
      variantHtmlBundle += '<div class="item-price"><span class="compare-at-price">' + varaintCPrice + '</span><span class="sale-price">' + varaintPrice + '</span></div></div>';

      totalQuantity += parseInt(variantQuantity);
      totalPrice += (parseInt(variantOriginlPrice) * variantQuantity);
      if (variantOriginlCPrice !== '' && variantOriginlCPrice !== undefined) {
        totalComparePrice += (parseInt(variantOriginlCPrice) * variantQuantity);
      }
    }

    if (stickyCart && variantHtmlBundle !== '') {
      variantHtmlBundle += blankBoxHtml();
      var itemsContainer = findOne(stickyCart, '.items-container');
      if (itemsContainer) html(itemsContainer, variantHtmlBundle);
    }

  } else {
    findIn(section, '.item-card.blank-card').forEach(function (el) { show(el); });
    var sc = findOne(section, '.sticky-cart-container');
    if (sc) hide(sc);
    resetTabsAndProgress();
  }

  var totals = calculateStrapTotals(bundleVariantData);
  totalPrice = totals.totalPrice;
  totalComparePrice = totals.totalComparePrice;

  var priceSection = findOne(section, '.price-section');
  if (priceSection && findOne(priceSection, '.main-price')) {
    var savingPrice = 0;
    if (totalComparePrice !== 0 && parseInt(totalComparePrice) > parseInt(totalPrice)) {
      savingPrice = parseInt(totalComparePrice) - parseInt(totalPrice);
    }

    var comparePriceEl = findOne(priceSection, '.original-price.compare-price');
    var savingsBadge = findOne(priceSection, '.savings-badge');

    if (savingPrice > 0) {
      if (comparePriceEl) show(comparePriceEl);
      if (savingsBadge) show(savingsBadge);
      var savingFormatted = Shopify.formatMoney(savingPrice);
      if (savingsBadge) text(savingsBadge, savingFormatted);
    } else {
      if (comparePriceEl) hide(comparePriceEl);
      if (savingsBadge) hide(savingsBadge);
    }

    console.log('totalComparePrice', totalComparePrice);
    var formattedCompare = Shopify.formatMoney(totalComparePrice);
    var formattedPrice = Shopify.formatMoney(totalPrice);

    if (comparePriceEl) text(comparePriceEl, formattedCompare);
    var mainPriceEl = findOne(priceSection, '.discounted-price.main-price');
    if (mainPriceEl) text(mainPriceEl, formattedPrice);

    var cartFooter = findOne(section, '.product-cart-footer');
    if (cartFooter) {
      var compareSubTotal = findOne(cartFooter, '.original-price.compare-sub-total');
      var subTotal = findOne(cartFooter, '.current-price.sub-total');
      if (compareSubTotal) text(compareSubTotal, formattedCompare);
      if (subTotal) text(subTotal, formattedPrice);
    }
  }

  bundleMessageCount();
}

// ============================================================
// CHECKOUT BUTTON → ADD TO CART
// ============================================================

on('click', '.multi-step-bundle-builder-section .checkout-button', function () {
  bundlePackAddToCart();
});

function bundlePackAddToCart() {
  if (bundleVariantData.length === 0) return;

  var section = qs('.multi-step-bundle-builder-section');
  var bannerWrapper = section ? findOne(section, '.block-banner-content-wrapper') : null;
  if (bannerWrapper) {
    var checkoutBtn = findOne(bannerWrapper, '.checkout-button');
    if (checkoutBtn) addClass(checkoutBtn, 'btn--loading');
  }

  var itemArr = [];
  for (var i = 0; i < bundleVariantData.length; i++) {
    if (bundleVariantData[i]) {
      itemArr.push({
        id: parseInt(bundleVariantData[i].variant_id),
        quantity: parseInt(bundleVariantData[i].variant_quantity),
        properties: { '__single_bundle': 1 }
      });
    }
  }

  if (itemArr.length > 0) {
    ajax({
      type: 'POST',
      url: '/cart/add.js',
      contentType: 'application/json',
      data: JSON.stringify({ items: itemArr }),
      success: function () { window.location.href = '/checkout'; },
      error: function () {
        if (bannerWrapper) {
          var checkoutBtn2 = findOne(bannerWrapper, '.checkout-button');
          if (checkoutBtn2) removeClass(checkoutBtn2, 'btn--loading');
        }
        console.log('fail');
      }
    });
  }
}

// ============================================================
// SAME BOX CARD (EQUAL HEIGHT)
// ============================================================

function sameBoxCard() {
  qsa('.multi-step-bundle-builder-section .block-item').forEach(function (wrapper) {
    var widthVersion = 2;
    var winWidth = window.innerWidth;
    if (winWidth >= 1250) widthVersion = 4;
    else if (winWidth > 900) widthVersion = 4;
    else if (winWidth > 600) widthVersion = 3;
    else widthVersion = 2;

    console.log('widthVersion', widthVersion);

    var cards = findIn(wrapper, '.product-info');
    if (cards.length === 0) return;

    cards.forEach(function (card) {
      var els = findIn(card, '.product-title, .jdgm-preview-badge, .color-variant, .other-options, .product-description');
      els.forEach(function (el) { el.style.height = 'auto'; });
    });

    for (var i = 0; i < cards.length; i += widthVersion) {
      var rowItems = cards.slice(i, i + widthVersion);

      function setMaxHeight(selector) {
        var maxHeight = 0;
        rowItems.forEach(function (card) {
          var el = findOne(card, selector);
          if (el) {
            var h = el.offsetHeight;
            if (h > maxHeight) maxHeight = h;
          }
        });

        if (selector === '.jdgm-preview-badge') {
          if (maxHeight > 0) {
            rowItems.forEach(function (card) {
              var badge = findOne(card, '.jdgm-preview-badge');
              if (badge) {
                badge.style.height = maxHeight + 'px';
              } else {
                var titleEl = findOne(card, '.product-title');
                if (titleEl) {
                  titleEl.insertAdjacentHTML('afterend', '<div class="jdgm-preview-badge" style="visibility:hidden;height:' + maxHeight + 'px;"></div>');
                }
              }
            });
          }
        } else {
          if (maxHeight > 0) {
            rowItems.forEach(function (card) {
              var el = findOne(card, selector);
              if (el) el.style.height = maxHeight + 'px';
            });
          }
        }
      }

      setMaxHeight('.product-title');
      setMaxHeight('.jdgm-preview-badge');
      setMaxHeight('.color-variant');
      setMaxHeight('.other-options');
      setMaxHeight('.product-description');
    }
  });
}

// ============================================================
// STICKY CART REMOVE BUTTON CLICK
// ============================================================

on('click', '.multi-step-bundle-builder-section .item-card.image-added .remove-btn', function () {
  var card = closest(this, '.item-card');
  var getVId = card ? card.dataset.variantId : null;
  if (!getVId) return;

  card.remove();

  var section = qs('.multi-step-bundle-builder-section');
  var input = findOne(section, '.collection-item .quantity-selector .quantity-value[data-variant-id="' + getVId + '"]');
  var current = input ? (parseInt(val(input)) || 1) : 1;

  if (!input) {
    var removeIndex = bundleVariantData.findIndex(function (item) { return item.variant_id == getVId; });
    if (removeIndex > -1) bundleVariantData.splice(removeIndex, 1);

  } else if (current === 1) {
    var removeIndex2 = bundleVariantData.findIndex(function (item) { return item.variant_id == getVId; });
    if (removeIndex2 > -1) bundleVariantData.splice(removeIndex2, 1);

    if (input.parentElement) hide(input.parentElement);
    var pb = findOne(input.parentElement.parentElement, '.product-btn');
    if (pb) show(pb);

    if (bundleVariantData.length === 0) {
      findIn(section, '.price-section .original-price.compare-price').forEach(function (el) { hide(el); });
      var tprice = Shopify.formatMoney(0);
      findIn(section, '.price-section .discounted-price.main-price').forEach(function (el) { text(el, tprice); });
    }
  } else {
    var newVal = current - 1;
    var variantIndex = bundleVariantData.findIndex(function (item) { return item.variant_id == getVId; });
    if (variantIndex > -1) bundleVariantData.splice(variantIndex, 1);
    val(input, newVal);
    input.dispatchEvent(new Event('change'));
    if (input.parentElement) show(input.parentElement);
    var pb2 = findOne(input.parentElement.parentElement, '.product-btn');
    if (pb2) hide(pb2);
  }

  setTimeout(bundlePackHtml, 100);
});

// ============================================================
// BLANK BOX HTML
// ============================================================

function blankBoxHtml() {
  var section = qs('.multi-step-bundle-builder-section');
  if (section) {
    findIn(section, '.sticky-cart-container .item-card:not(.blank-card)').forEach(function (el) { el.remove(); });
  }
  return '<div class="item-card blank-card"><div class="item-image"><div class="plus-icon">' +
    '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">' +
    '<path d="M16.0002 7.61133V25.3891M7.11133 16.5002H24.8891" stroke="#0F0F0F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>' +
    '</svg>FREE</div></div></div>';
}

// ============================================================
// BUNDLE MESSAGE COUNT
// ============================================================

function bundleMessageCount() {
  var strapCheck = 0, productCount = 0;
  var section = qs('.multi-step-bundle-builder-section');
  if (!section) return;

  if (bundleVariantData.length > 0) {
    for (var i = 0; i < bundleVariantData.length; i++) {
      if (bundleVariantData[i]) {
        var pt = bundleVariantData[i].product_title.toLowerCase();
        if (pt && pt.includes('strap') && !pt.includes('strap bag')) {
          strapCheck = 1;
          productCount++;
        }
      }

      var stickyCart = findOne(section, '.sticky-cart-container');
      if (stickyCart) {
        productCount = parseInt(productCount);
        if (productCount > 0) {
          var freeStrapTitle = findOne(stickyCart, '.cart-title.free-strap');
          var noFreeTitle = findOne(stickyCart, '.cart-title.no-free');
          var freeShipRow = findOne(section, '.product-cart-wrapper .price-row.free-shipping-row');

          if (freeStrapTitle) hide(freeStrapTitle);
          if (noFreeTitle) {
            show(noFreeTitle);
            var spanEl = findOne(noFreeTitle, 'span');
            if (spanEl) text(spanEl, '(' + bundleVariantData.length + ')');
          }
          if (freeShipRow) show(freeShipRow);
        }
      }
    }
  } else {
    var freeStrapTitle2 = findOne(section, '.sticky-cart-container .cart-title.free-strap');
    var noFreeTitle2 = findOne(section, '.sticky-cart-container .cart-title.no-free');

    if (freeStrapTitle2) {
      show(freeStrapTitle2);
      var strongEl = findOne(freeStrapTitle2, 'strong');
      if (strongEl) text(strongEl, '3 straps');
    }
    if (noFreeTitle2) hide(noFreeTitle2);
  }
}

// ============================================================
// RESERVE TIMER
// ============================================================

var timerInterval;

function reserveTimer() {
  var section = qs('.multi-step-bundle-builder-section');
  if (!section) return;
  var reviewBlock = findOne(section, '.block-item.review-block');
  if (!reviewBlock) return;

  if (data(reviewBlock, 'timer-running')) return;

  var getMinute = attr(reviewBlock, 'data-time');
  if (!getMinute || getMinute === '') return;

  var totalSeconds = parseInt(getMinute) * 60;

  function updateTimer() {
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    var timerEl = findOne(reviewBlock, '.cart-reserve-timer');
    if (timerEl) {
      text(timerEl,
        (hours < 10 ? '0' + hours : hours) + ':' +
        (minutes < 10 ? '0' + minutes : minutes) + ':' +
        (seconds < 10 ? '0' + seconds : seconds)
      );
    }
  }

  timerInterval = setInterval(function () {
    if (totalSeconds <= 0) {
      clearInterval(timerInterval);
      var timerEl = findOne(reviewBlock, '.cart-reserve-timer');
      if (timerEl) text(timerEl, '00:00:00');
      data(reviewBlock, 'timer-running', false);
    } else {
      totalSeconds--;
      updateTimer();
    }
  }, 1000);

  data(reviewBlock, 'timer-running', true);
  updateTimer();
}


/* =============================================
PRODUCT CARD SLIDER -- START
============================================= */
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".pro-collection-gallery").forEach(slider => {
        new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            pagination: {
            el: slider.querySelector(".swiper-pagination"),
            clickable: true
        },
        //   breakpoints: {
        //     640: {
        //       slidesPerView: 2
        //     },
        //     1024: {
        //       slidesPerView: 3
        //     }
        //   }
        });
    });
}); 
/* =============================================
PRODUCT CARD SLIDER -- END
============================================= */


// PRODUCT SIZE CHART -- START

document.addEventListener("DOMContentLoaded", function () {

  const sizeGuideCtas = document.querySelectorAll(".size-guide-cta");
  const modal = document.querySelector(".modal-product-size");
  const modalBtns = document.querySelectorAll(".modal-btn");
  const body = document.body;

  function openModal() {
    if (!modal) return;

    modal.style.display = "block";
    modal.classList.add("active");

    const existingBackdrop = document.querySelector(".modal-backdrop");
    if (existingBackdrop) existingBackdrop.remove();

    const backdrop = document.createElement("div");
    backdrop.className = "modal-backdrop fade";
    body.appendChild(backdrop);
  }

  function closeModal() {
    if (!modal) return;

    modal.style.display = "none";
    modal.classList.remove("active");

    const backdrop = document.querySelector(".modal-backdrop");
    if (backdrop) backdrop.remove();
  }

  // Open modal on CTA click
  sizeGuideCtas.forEach(btn => {
    btn.addEventListener("click", openModal);
  });

  // Close button click
  modalBtns.forEach(btn => {
    btn.addEventListener("click", closeModal);
  });

  // Click outside modal-content closes modal
  if (modal) {
    modal.addEventListener("click", function (e) {
      if (!e.target.closest(".modal-content")) {
        closeModal();
      }
    });
  }

});

// PRODUCT SIZE CHART -- END